// Matches DEFAULT_LOOKBACK_DAYS in template_mapping/opendock_onboard/onboard_processor.py.
export const DEFAULT_LOOKBACK_DAYS = 180

// The columns an uploaded sheet must carry to be rebuilt into questions. A sheet edited in a
// spreadsheet often gains columns or reorders them, so this is a subset, not an equality check.
export const REQUIRED_UPLOAD_COLUMNS = [
    'warehouse_id', 'var_name', 'proposed_type', 'proposed_value',
]

// API Gateway cuts a request off at 29s, and the read signs in, pulls every appointment in the
// window, then every warehouse booked at and its load types, all before it answers.
export const GATEWAY_TIMEOUT_NOTE = 'Reading a long booking history takes a while. '
    + 'The gateway gives it 29 seconds. If it times out, try a shorter lookback.'
